import { AuthHeader } from '@/components/auth/AuthHeader';
import { CLIENT_PORTAL_DISABLED_MESSAGE } from '@core/portal/clientPortal.util';

const ClientPortalDisabledScreen = () => (
  <div className="flex min-h-screen w-full items-center justify-center bg-white">
    <div className="w-full max-w-md px-6 py-8 text-center">
      <AuthHeader title="Web portal unavailable" />
      <p className="text-sm text-gray-600">{CLIENT_PORTAL_DISABLED_MESSAGE}</p>
    </div>
  </div>
);

export default ClientPortalDisabledScreen;
